export default __webpack_public_path__ + "static/media/mechanical.86c868ba.svg";